import axios from "axios";
    
declare var process: { env: { REACT_APP_API_BASE_URL: string } };

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, 
  headers: {
    "Content-Type": "application/json",
  },
});

axiosApi.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosApi;
